module.exports = __webpack_public_path__ + "img/多多_暗.42dcb971.png";